module.exports = __webpack_public_path__ + "img/brain-blue-full.333719ac.svg";